import { http } from '../../../../api/http';

export interface CuentaBancariaTrabajador {
  idCuentaBancaria: number;
  idTrabajador: number;
  nombreBanco: string;
  numeroCuenta: string;
  cci: string | null;
  codigoOficina: string | null;
  tipoCuenta: string; // HABERES, CTS, OTROS
  esPrincipal: boolean;
}

export const initialCuentaBancaria: CuentaBancariaTrabajador = {
  idCuentaBancaria: 0,
  idTrabajador: 0,
  nombreBanco: '',
  numeroCuenta: '',
  cci: null,
  codigoOficina: null,
  tipoCuenta: 'HABERES',
  esPrincipal: false,
};

const BASE = '/planilla/cuenta-bancaria';

export class CuentaBancariaService {
  static async getByTrabajador(idTrabajador: number): Promise<CuentaBancariaTrabajador[]> {
    const { data } = await http.get(`${BASE}/trabajador/${idTrabajador}`);
    return data;
  }

  static async save(cuenta: CuentaBancariaTrabajador): Promise<CuentaBancariaTrabajador> {
    const { data } = await http.post(BASE, cuenta);
    return data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${BASE}/${id}`);
  }
}
